/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "popup-captcha": {
      "validate": "Continue",
      "title": "Enter the Captcha Code to continue",
      "tips1": "Why you see this dialog?",
      "tips2": "Zoom has detected unusual traffic from your device. The dialog verifies whether you or a robot is sending these requests."
    }
  },
  "de-DE": {
    "popup-captcha": {
      "validate": "Weiter",
      "title": "Zum Weitermachen geben Sie den Captcha-Code ein",
      "tips1": "Warum Sie diesen Dialog sehen?",
      "tips2": "Zoom registriert auffälligen Datenverkehr von Ihrem Gerät. Dieser Dialog prüft, ob Sie oder ein Roboter diese Anfragen stellt."
    }
  },
  "es-ES": {
    "popup-captcha": {
      "validate": "Continuar",
      "title": "Introduzca el código CAPTCHA para continuar",
      "tips1": "¿Por qué ve este cuadro de diálogo?",
      "tips2": "Zoom ha detectado tráfico inusual desde su dispositivo. El cuadro de diálogo verifica si usted o un robot está enviado estas solicitudes."
    }
  },
  "fr-FR": {
    "popup-captcha": {
      "validate": "Continuer",
      "title": "Saisissez le code Captcha pour continuer",
      "tips1": "Pourquoi voyez-vous cette boîte de dialogue ?",
      "tips2": "Zoom a détecté un trafic inhabituel provenant de votre appareil. La boîte de dialogue vérifie si ces demandes sont envoyées par vous ou par un robot."
    }
  },
  "id-ID": {
    "popup-captcha": {
      "validate": "Lanjutkan",
      "title": "Masukkan Kode Captcha untuk melanjutkan",
      "tips1": "Mengapa Anda melihat dialog ini?",
      "tips2": "Zoom telah mendeteksi lalu lintas yang tidak biasa dari perangkat Anda. Dialog ini memverifikasi apakah Anda atau robot yang mengirim permintaan ini."
    }
  },
  "it-IT": {
    "popup-captcha": {
      "validate": "Continua",
      "title": "Inserisci il codice Captcha per continuare",
      "tips1": "Perché vedi questa finestra di dialogo?",
      "tips2": "Zoom ha rilevato un traffico insolito dal tuo dispositivo. La finestra di dialogo verifica se queste richieste sono inviate da un robot."
    }
  },
  "jp-JP": {
    "popup-captcha": {
      "validate": "続行",
      "title": "続行するにはCAPTCHAコードを入力してください",
      "tips1": "このダイアログが表示されるのは次のような理由からです。",
      "tips2": "Zoomにより、デバイスからの異常なトラフィックが検出されました。このダイアログは、これらの要求があなたまたはロボットのどちらによって送信されているかを確認します。"
    }
  },
  "ko-KO": {
    "popup-captcha": {
      "validate": "계속",
      "title": "계속하려면 CAPTCHA 코드를 입력하세요",
      "tips1": "이 대화 상자가 표시된 이유",
      "tips2": "Zoom이 귀하의 장치에서 비정상적인 트래픽을 감지했습니다. 대화 상자는 이 요청을 보낸 것이 귀하인지 로봇인지 확인합니다."
    }
  },
  "nl-NL": {
    "popup-captcha": {
      "validate": "Doorgaan",
      "title": "Voer de captcha-code in om door te gaan",
      "tips1": "Waarom krijgt u deze dialoog te zien?",
      "tips2": "Zoom heeft ongebruikelijk verkeer vanaf uw apparaat gedetecteerd. De dialoog verifieert of deze verzoeken door u of door een robot worden verzonden."
    }
  },
  "pl-PL": {
    "popup-captcha": {
      "validate": "Kontynuuj",
      "title": "Wprowadź kod Captcha, aby kontynuować",
      "tips1": "Dlaczego widzisz to okno?",
      "tips2": "Aplikacja Zoom wykryła nietypowy ruch z Twojego urządzenia. Okno dialogowe sprawdza, czy żądania są wysyłane przez człowieka, czy robota."
    }
  },
  "pt-PT": {
    "popup-captcha": {
      "validate": "Continuar",
      "title": "Insira o código captcha para continuar",
      "tips1": "Por que você vê esta caixa de diálogo?",
      "tips2": "O Zoom detectou tráfego incomum em seu dispositivo. A caixa de diálogo verifica se você ou um robô está enviando estas solicitações."
    }
  },
  "ru-RU": {
    "popup-captcha": {
      "validate": "Продолжить",
      "title": "Введите код Captcha, чтобы продолжить",
      "tips1": "Почему отображается это диалоговое окно?",
      "tips2": "Zoom обнаружил необычный трафик, исходящий с вашего устройства. Диалоговое окно позволяет проверить, кто отправляет эти запросы — вы или робот."
    }
  },
  "tr-TR": {
    "popup-captcha": {
      "validate": "Devam",
      "title": "Devam etmek için Captcha Kodunu girin",
      "tips1": "Bu diyaloğu neden görüyorsunuz?",
      "tips2": "Zoom, cihazınızdan gelen olağan dışı trafik algıladı. İletişim kutusu, bu istekleri sizin mi yoksa bir robotun mu gönderdiğini doğrular."
    }
  },
  "vi-VN": {
    "popup-captcha": {
      "validate": "Tiếp tục",
      "title": "Nhập mã Captcha để tiếp tục",
      "tips1": "Tại sao bạn nhìn thấy hộp thoại này?",
      "tips2": "Zoom đã phát hiện lưu lượng truy cập bất thường từ thiết bị của bạn. Hộp thoại xác minh xem liệu bạn hay robot đang gửi những yêu cầu này."
    }
  },
  "zh-CN": {
    "popup-captcha": {
      "validate": "继续",
      "title": "输入验证码以继续",
      "tips1": "你为何会看到此对话？",
      "tips2": "Zoom检测到你的设备存在异常流量。此对话用于验证这些请求的发送者是你本人还是机器人。"
    }
  },
  "zh-TW": {
    "popup-captcha": {
      "validate": "繼續",
      "title": "輸入Captcha代碼以繼續",
      "tips1": "為何您會看到此對話方塊？",
      "tips2": "Zoom已偵測到來自您裝置的異常傳輸流量。對話方塊將會驗證是您本人還是機器人在傳送這些要求。"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
